import React from 'react';

import { Tooltip } from '@mui/material';

import { TooltipTitle } from './styles';
import { format } from '../../../../date-fns-locale';

interface ClassesDateRangeProps {
    start?: string;
    end?: string;
}

const ClassesDateRange: React.FC<ClassesDateRangeProps> = ({ start, end }) => {
    if (typeof start !== 'string' || typeof end !== 'string') return null;

    const firstClassInLocalStyle = new Date(start).toLocaleDateString();
    const lastClassInLocalStyle = new Date(end).toLocaleDateString();

    const firstFormattedFull = format(new Date(start), 'MMMM dd, yyyy');
    const lastFormattedFull = format(new Date(end), 'MMMM dd, yyyy');

    return (
        <Tooltip
            arrow
            title={
                <TooltipTitle>
                    {firstFormattedFull} - {lastFormattedFull}
                </TooltipTitle>
            }
        >
            <span>
                {firstClassInLocalStyle} - {lastClassInLocalStyle}
            </span>
        </Tooltip>
    );
};

export default ClassesDateRange;
